import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import TextField from 'components/text-field';
import { TFunction } from 'i18next';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  titleContainer: { paddingBottom: theme.spacing(2) },
  title: {
    textAlign: 'center',
    color: theme.palette.tab.offselected,
    [theme.breakpoints.down('sm')]: { fontSize: theme.typography.body1.fontSize },
  },
  // Full width on phones; bounded and centered from sm up.
  field: {
    width: '100%',
    [theme.breakpoints.up('sm')]: { maxWidth: theme.spacing(75) },
  },
}));

type SearchFieldProps = {
  t: TFunction;
  searchText: string | undefined;
  handleSearch: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

const SearchField: FC<SearchFieldProps> = ({ t, searchText, handleSearch }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row">
      <Grid item xs={12} className={classes.titleContainer}>
        <Typography variant="h6" component="h2" className={classes.title}>
          {t('users:search-parties-orgs')}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container direction="row" justifyContent="center">
          <Grid item className={classes.field}>
            <TextField
              fullWidth
              label={t('users:placeholder-search-parties-orgs')}
              value={searchText}
              onChange={handleSearch}
              placeholder={t('parties:type-as-3-characters')}
              inputProps={{
                maxLength: 40,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SearchField;
